type CitationSource = { book_id?: string; book_title?: string; chapter_title?: string; page?: number | null };

/** Keep every page and chapter attached to its own book, including page-less sources. */
export function citationLabels(citations: CitationSource[]): string[] {
  const groups = new Map<string, CitationSource[]>();
  for (const citation of citations) {
    const key = citation.book_id || citation.book_title || 'unknown';
    groups.set(key, [...(groups.get(key) ?? []), citation]);
  }
  return [...groups.values()].map((group) => {
    const pages = [...new Set(group.flatMap((item) => item.page == null ? [] : [item.page]))].sort((a, b) => a - b);
    const chapters = [...new Set(group.map((item) => item.chapter_title).filter(Boolean))];
    return [`📘 《${group[0]?.book_title || '未命名资料'}》`, pages.map((page) => `P.${page}`).join(' / '), chapters.join(' / ')].filter(Boolean).join(' · ');
  });
}
